import React from 'react';
import SpeakerCard from '../components/speakers/SpeakerCard';
import './SpeakersPage.css';

import ProfJoseToreroCullen from '../assets/plenarySpeakers/ProfJoseToreroCullen.jpeg';
import ProfHongHao from '../assets/plenarySpeakers/ProfHongHao.jpg';
import ProfJamesMRicles from '../assets/plenarySpeakers/ProfJamesMRicles.jpg';
import ProfGuoweiMa from '../assets/plenarySpeakers/ProfGuoweiMa.jpg';
import ProfYBYang from '../assets/plenarySpeakers/ProfYBYang.jpeg';
import ProfHerbertMang from '../assets/plenarySpeakers/ProfHerbertMang.jpg';

const plenarySpeakers = [
  {
    name: 'Prof Jose Torero Cullen',
    affiliation: 'University College London',
    bio: 'Professor and Head of the Department of Civil, Environmental & Geomatic Engineering at University College London, specializing in fire safety and complex infrastructure systems',
    photo: ProfJoseToreroCullen,
    affiliationUrl: 'https://profiles.ucl.ac.uk/70564-jose-torero-cullen'
  },
  {
    name: 'Prof Hong Hao',
    affiliation: 'Curtin University',
    bio: 'John Curtin Distinguished Professor in Civil and Mechanical Engineering at the Centre for Infrastructural Monitoring & Protection, Curtin University',
    photo: ProfHongHao,
    affiliationUrl: 'https://staffportal.curtin.edu.au/staff/profile/view/Hong.Hao'
  },
  {
    name: 'Prof James M. Ricles',
    affiliation: 'Lehigh University',
    bio: 'Professor and Director of the ATLSS Engineering Research Center at Lehigh University, specializing in structural engineering and real-time cyber-physical simulation',
    photo: ProfJamesMRicles,
    affiliationUrl: 'https://engineering.lehigh.edu/faculty/james-m-ricles'
  },
  {
    name: 'Prof Guowei Ma',
    affiliation: 'Shaoxing University',
    bio: 'Professor and Director of State Key Laboratory of Intelligent Deep Metal Mining and Equipment (Shaoxing University)',
    photo: ProfGuoweiMa,
    affiliationUrl: 'https://teacher.hebut.edu.cn/publish/2017146d15d8fb8c11edab95286ed488d6f1010/'
  },
  {
    name: 'Prof YB Yang',
    affiliation: 'Chongqing University',
    bio: 'Professor in Structural Engineering at Chongqing University, specializing in structural stability, bridge dynamics, and disaster prevention',
    photo: ProfYBYang,
    affiliationUrl: 'https://ecivil.cqu.edu.cn/info/1011/1387.htm'
  },
  {
    name: 'Prof Herbert Mang',
    affiliation: 'Research Unit Strength of Materials and Biomechanics & Tongji University',
    bio: 'Professor Emeritus at the Vienna University of Technology and Full Professor at the Tongji University, specializing in structural mechanics, computational mechanics, and multi-scale analysis of materials and structures.',
    photo: ProfHerbertMang,
    affiliationUrl: 'https://www.tuwien.at/en/cee/imws/strength/team/herbert-mang'
  }
  // {
  //   name: ' ',
  //   affiliation: ' ',
  //   bio: ' ',
  //   photo: null,
  //   affiliationUrl: ' '
  // }
];

const PlenarySpeakersPage = () => {
  return (
    <section className="speakers-page fade-in-up">
      <div className="container-large">
        <h1 className="speakers-heading">Plenary Speakers</h1>
        <div className="speakers-grid">
          {plenarySpeakers.map((spk, idx) => (
            <SpeakerCard key={spk.name} speaker={spk} style={{ animationDelay: `${idx * 0.1}s` }} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlenarySpeakersPage;
